import { Component, ElementRef, Inject } from '@angular/core';

import { applyStyles } from '../../../function/apply-styles.function';
import { CPopTemplateDataElement } from '../../../model/c-pop-template-data-element.model';
import { CMPS_EC_DATA_ELEMENT } from '../../../model/metadata';

@Component({
    selector: 'cmps-event-centre-c-pop-data-v1',
    templateUrl: './data-v1.component.html',
    host: {
        class: 'cmps-event-centre-c-pop-data-v1 cmps-cdk-d-block',
    },
})
export class DataV1Component {
    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        /** @private */ @Inject(CMPS_EC_DATA_ELEMENT)
        readonly _data: CPopTemplateDataElement,
    ) {
        applyStyles(this._el.nativeElement, this._data.styles);
    }
}
